/**
 * Directive: resourceRequestNeed
 */
angular.module('acme.common.directive.resourceRequestNeed', [
  'selectize',
  'acme.common.service.api',
  'acme.common.factory.gridState',
  'acme.common.service.permissions'
])
.directive('resourceRequestNeed', [ 'ApiService', function(ApiService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceRequest/need/need.tpl.html',
      scope: {
        resourceCategory: '@',
        type: '@',
        preset: '@',
        model: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$timeout', '$filter', 'GridStateFactory', 'PermissionsService', function($scope, $timeout, $filter, GridStateFactory, PermissionsService) {

        $scope.resourceRequestNeed = {

          templatesGridState: new GridStateFactory(),
          resourcesGridState: new GridStateFactory(),

          requestType: {},
          resourceTemplate: '',
          resource: '',
          resources: [],
          resourceTemplates: [],
          showMoreTemplates: {},
          showMoreResources: {},
          errorMessage: '',
          hasError: false,
          reduceList: false,
          pageSize: 4,
          lastResourceCategory: '',
          resourceCategories: [
            {
              category: 'personnel',
              name: 'People',
              lastSearch: '',
              show: PermissionsService.check(['RESOURCES_REQUESTS_PERSON_CREATE', 'RESOURCES_REQUESTS_UPDATE'])
            },
            {
              category: 'facilities',
              name: 'Places',
              lastSearch: '',
              show: PermissionsService.check(['RESOURCES_REQUESTS_PLACE_CREATE', 'RESOURCES_REQUESTS_UPDATE'])
            },
            {
              category: 'equipment',
              name: 'Equipment',
              lastSearch: '',
              show: PermissionsService.check(['RESOURCES_REQUESTS_EQUIPMENT_CREATE', 'RESOURCES_REQUESTS_UPDATE'])
            }
          ],

          requestTypes: [
            {
              type: 'resourceCategory',
              label: 'Type'
            },
            {
              type: 'resource',
              label: 'Resource'
            }
          ],

          selectizeConfig: {
            create: false,
            valueField: 'value',
            labelField: 'value',
            searchField: ['value'],
            items: [],
            placeholder: 'Optional - pick specific attributes...',
            onInitialize: function(selectize) {
              // receives the selectize object as an argument
              selectize.$control.find('input').attr('id', 'resource-request-need-attributes');
            }
          },

          model: {
            type: '',
            resourceId: null,
            resourceTemplateId: '',
            quantity: 1,
            values: []
          },

          init: function() {
            this.requestType = this.requestTypes[0].type;

            if ($scope.model) {
              if ($scope.model.resourceTemplateId) {
                this.model.resourceTemplateId = $scope.model.resourceTemplateId;
              }
              if ($scope.model.resourceTemplateName) {
                this.model.resourceTemplateName = $scope.model.resourceTemplateName;
              }

              if ($scope.model.resourceId) {
                this.requestType = this.requestTypes[1].type;
                this.model.resourceId = $scope.model.resourceId;
              }

              if ($scope.model.type) {
                this.model.type = $scope.model.type;
              }

              if ($scope.model.quantity) {
                this.model.quantity = $scope.model.quantity;
              }

              if ($scope.model.values) {
                this.model.values = $scope.model.values;
              }
            }

            if ($scope.resourceCategory) {
              var found = this.findResourceCategory($scope.resourceCategory);
              if (found) {
                this.model.resourceCategory = found.category.category;
              }else{
                this.model.resourceCategory = this.resourceCategories[0].category;
              }
            }else{
              this.model.resourceCategory = this.resourceCategories[0].category;
            }

            this.lastResourceCategory = this.model.resourceCategory;

            this.templatesGridState.updateGridState(null, this.pageSize, 'name', 'asc');
            this.resourcesGridState.updateGridState(null, this.pageSize, 'name', 'asc');

            if (this.requestType === 'resourceCategory') {
              this.getResourceTemplates(this.model.resourceCategory);
            }else {
              this.getResources(this.model.resourceCategory);
            }

            $scope.$on('$destroy', $scope.$watch('resourceRequestNeed.requestType', this.onRequestTypeUpdate));
            $scope.$on('$destroy', $scope.$watch('resourceRequestNeed.model.resourceCategory', this.onRequestCategoryUpdate));
            $scope.$on('$destroy', $scope.$watch('resourceRequestNeed.resourceTemplate', this.onResourceTemplateUpdate));
            $scope.$on('$destroy', $scope.$watch('resourceRequestNeed.resource', this.onResourceUpdate));
            $scope.$on('$destroy', $scope.$watch('resourceRequestNeed.model.quantity', this.onQuantityUpdate));

            $scope.$on('$destroy', $scope.$watchCollection('resourceRequestNeed.model', function(n, o) {
              $scope.model = angular.copy(n);
            }));

            $scope.$on('ResourceRequest::Complete', this.onResourceRequestComplete);
            
          },

          getResourceTemplates: function(resourceCategory) {
            var props = this.templatesGridState.getGridState();
            if ($scope.model && $scope.model.type && resourceCategory === this.lastResourceCategory) {
              props.search = $scope.model.type;
            }
            ApiService.resource.templates($.extend({
              resourceCategory: resourceCategory
            }, props)).then(this.success.getResourceTemplates, this.error.getResourceTemplates);
            this.lastResourceCategory = resourceCategory;
          },

          getResources: function(resourceCategory) {
            var props = this.resourcesGridState.getGridState();
            if ($scope.model && $scope.model.resourceName && resourceCategory === this.lastResourceCategory) {
              props.search = $scope.model.resourceName;
            }
            ApiService.resource.instances.filterList($.extend({
              category: resourceCategory
            }, props)).then(this.success.getResources, this.error.getResources);
            this.lastResourceCategory = resourceCategory;
          },

          showAutoComplete: function(field) {

            var input = $('#'+field);

            this.reduceList = false;

            $timeout(function () {
              input.trigger('focus');
            }, 0);

          },

          checkValid: function() {
            var r = true;

            if (!this.resource && !this.resourceTemplate) {
              r = false;
              if (this.requestType === 'resource') {
                this.errorMessage = 'You must select a resource';
              }else if (this.requestType === 'resourceCategory') {
                this.errorMessage = 'You must select a template';
              }
            }else if ((!this.resourceTemplate && !this.resource) || (this.resourceTemplate && !this.resourceTemplate.id)) {
              r = false;
              this.errorMessage = 'You must select a template';
            }else if ((!this.resourceTemplate && !this.resource) || (this.resource && !this.resource.resourceTemplateId)) {
              r = false;
              this.errorMessage = 'Invalid resource: resource has no template';
            }

            return r;
          },

          hasResource: function() {
            return (this.resource && typeof this.resource === 'object');
          },

          searchResources: function(field, resourceCategory) {
            this.searching = true;
            ApiService.resource.instances.filterList($.extend({
              category: resourceCategory
            }, this.resourcesGridState.getGridState())).then(function(response) {
              $scope.resourceRequestNeed.success.searchResources(response, field);
            }, this.error.searchResources);
          },

          showMoreListResults: function(item) {
            switch(item.field) {
              case 'resource-request-need-templates-list':
                this.filterTemplatesList(true, item.field);
                break;
              case 'resource-request-need-resource-list':
                this.filterResourcesList(true, item.field);
                break;
            }
          },

          hasResourceTemplate: function() {
            return (this.resourceTemplate && typeof this.resourceTemplate === 'object');
          },

          searchTemplates: function(field, resourceCategory) {
            this.searching = true;
            ApiService.resource.templates($.extend({
              resourceCategory: resourceCategory
            }, this.templatesGridState.getGridState())).then(function(response) {
              $scope.resourceRequestNeed.success.searchTemplates(response, field);
            }, this.error.searchTemplates);
          },

          filterTemplatesList: function(force, field) {

            var timeoutMS = force ? 0 : 500;

            if (this.queryTimer) {
              $timeout.cancel(this.queryTimer);
            }

            this.queryTimer = $timeout(function () {
              var self = $scope.resourceRequestNeed;

              if (force || (typeof self.resourceTemplate === 'string') && (self.lastSearchQuery !== self.resourceTemplate)) {
                if (!force) {
                  self.templatesGridState.setPropertyValue('pageSize', self.pageSize);
                } else {
                  self.templatesGridState.setPropertyValue('pageSize', (self.templatesGridState.gridState.pageSize + self.pageSize) );
                }
                self.templatesGridState.gridState.search = self.hasResourceTemplate() ? '' : self.resourceTemplate;
                self.lastSearchQuery = self.templatesGridState.gridState.search;

                self.searchTemplates(field, self.model.resourceCategory);
              }
            }, timeoutMS);

          },

          filterResourcesList: function(force, field) {

            var timeoutMS = force ? 0 : 500;

            if (this.queryTimer) {
              $timeout.cancel(this.queryTimer);
            }

            this.queryTimer = $timeout(function () {
              var self = $scope.resourceRequestNeed;

              if (force || (typeof self.resource === 'string') && (self.lastSearchQuery !== self.resource)) {
                if (!force) {
                  self.resourcesGridState.setPropertyValue('pageSize', self.pageSize);
                } else {
                  self.resourcesGridState.setPropertyValue('pageSize', (self.resourcesGridState.gridState.pageSize + self.pageSize) );
                }
                self.resourcesGridState.gridState.search = self.hasResource() ? '' : self.resource;
                self.lastSearchQuery = self.resourcesGridState.gridState.search;

                self.searchResources(field, self.model.resourceCategory);
              }
            }, timeoutMS);

          },

          findResource: function(id) {

            var i, ii,
                r = false;

            for (i=0,ii=this.resources.length;i<ii;i++) {
              if (""+this.resources[i].id === ""+id) {
                r = {
                  resource: this.resources[i],
                  index: i
                };
                break;
              }
            }

            return r;

          },

          findResourceTemplate: function(id) {

            var i, ii,
              r = false;

            for (i=0,ii=this.resourceTemplates.length;i<ii;i++) {
              if (""+this.resourceTemplates[i].id === ""+id) {
                r = {
                  template: this.resourceTemplates[i],
                  index: i
                };
                break;
              }
            }

            return r;

          },

          findResourceCategory: function(category) {

            var i, ii,
                r = false,
                categoryEntityName;

            category = category || 'personnel';

            if (category.toLowerCase() === 'place') {
              categoryEntityName = 'facilities';
            } else {
              categoryEntityName = category.toLowerCase();
            }

            for (i=0,ii=this.resourceCategories.length;i<ii;i++) {
              if (this.resourceCategories[i].show && (this.resourceCategories[i].category === categoryEntityName)) {
                r = {
                  category: this.resourceCategories[i],
                  index: i
                };
                break;
              }
            }

            return r;

          },

          resetTemplate: function() {

            var found,
                self = $scope.resourceRequestNeed;

            $timeout(function() {
              //reset addon selected if no addon is chosen
              if (!self.hasResourceTemplate()) {
                found = self.findResourceTemplate(self.model.resourceTemplateId);

                if (found || self.currentAddon) {
                  self.resourceTemplate = !found ? self.resourceTemplate : self.resourceTemplates[found.index];
                }
              }
              this.reduceList = false;
            },0);

          },

          resetResource: function() {

            var found,
                self = $scope.resourceRequestNeed;

            $timeout(function() {
              //reset addon selected if no addon is chosen
              if (!self.hasResourceTemplate()) {
                found = self.findResource(self.model.resourceId);

                if (found || self.currentAddon) {
                  self.resource = !found ? self.resource : self.resources[found.index];
                }
              }
              this.reduceList = false;
            },0);

          },

          processTemplates: function (templates, count) {
            var r = templates,
                currentCount = (this.templatesGridState.gridState.page || 1) * this.templatesGridState.gridState.pageSize;

            //if there are more items for this search, show pagination
            if (count && count > currentCount) {
              this.showMoreTemplates = {
                showMoreLabel: 'Show '+ this.pageSize +' more of ' + count,
                hasMore: true
              };
            } else {
              this.showMoreTemplates = {
                showMoreLabel: '',
                hasMore: false
              };
            }

            return r;
          },

          processResources: function (resources, count) {

            var r = resources,
                currentCount = (this.resourcesGridState.gridState.page || 1) * this.resourcesGridState.gridState.pageSize;

            //if there are more items for this search, show pagination
            if (count && count > currentCount) {
              this.showMoreResources = {
                showMoreLabel: 'Show '+ this.pageSize +' more of ' + count,
                hasMore: true
              };
            } else {
              this.showMoreResources = {
                showMoreLabel: '',
                hasMore: false
              };
            }

            return r;
          },

          success: {
            getResourceTemplates: function(response) {
              var found,
                  self = $scope.resourceRequestNeed;

              self.resourceTemplates = self.processTemplates(response.data.payload.list, response.data.payload.pagination.count);
              if ($scope.model.resourceTemplateId) {
                found = self.findResourceTemplate($scope.model.resourceTemplateId);
                self.resourceTemplate = found ? found.template : '';
              } else {
                self.resourceTemplate = '';
              }
            },

            getResources: function(response) {
              var found,
                  self = $scope.resourceRequestNeed;

              self.resources = self.processResources(response.data.payload.list, response.data.payload.pagination.count);
              if ($scope.model.resourceId) {
                found = self.findResource($scope.model.resourceId);

                self.resource =  found ? found.resource : '';
              } else {
                self.resource = '';
              }
            },

            searchTemplates: function(response, field) {
              var self = $scope.resourceRequestNeed;

              self.resourceTemplates = self.processTemplates(response.data.payload.list, response.data.payload.pagination.count);

              if (field) {
                $scope.$broadcast('CustomTypeahead::FilterResults', { field: field });
              }

            },

            searchResources: function(response, field) {
              var self = $scope.resourceRequestNeed;

              self.resources = self.processResources(response.data.payload.list, response.data.payload.pagination.count);

              if (field) {
                $scope.$broadcast('CustomTypeahead::FilterResults', { field: field });
              }

            }
          },
          error: {
            getResourceTemplates: function(response) {},

            searchTemplates: function(response, field) {
              var self = $scope.resourceRequestNeed;
              self.resourceTemplates = [];
            },

            searchResources: function(response, field) {
              var self = $scope.resourceRequestNeed;
              self.resources = [];
            }
          },

          onRequestTypeUpdate: function(n, o) {
            var self = $scope.resourceRequestNeed;

            if (n !== o) {
              self.model.values = [];

              if (n === 'resourceCategory') {
                self.model.resourceId = null;
                self.model.resourceName = null;

                self.getResourceTemplates(self.model.resourceCategory);

              } else if (n === 'resource') {
                self.getResources(self.model.resourceCategory);
              }
            }

            $scope.$emit('ResourceRequestNeed::RequestTypeUpdate', { requestType: n });
          },

          onRequestCategoryUpdate: function(n, o) {

            var self = $scope.resourceRequestNeed;

            if (n !== o) {
              if (self.requestType === 'resourceCategory') {
                self.templatesGridState.setPropertyValue('search', '');
                self.getResourceTemplates(self.model.resourceCategory);
              } else if (self.requestType === 'resource') {
                self.resourcesGridState.setPropertyValue('search', '');
                self.getResources(self.model.resourceCategory);
              }
            }

            $scope.$emit('ResourceRequestNeed::RequestCategoryUpdate', { resourceCategory: self.model.resourceCategory });
          },

          onResourceTemplateUpdate: function(n, o) {
            var attrs = [],
                self = $scope.resourceRequestNeed;

            if (o) {
              self.model.values = [];
            }

            if (n !== o) {
              if (self.requestType === 'resourceCategory') {

                self.model.type = n.name;

                self.model.resourceTemplateId = n.id;
                self.model.resourceTemplateName = n.name;

                angular.forEach(n.fields, function(v, k) {
                  var i, ii;

                  if (v.values instanceof Array) {
                    for (i = 0, ii = v.values.length; i < ii; i++) {
                      attrs.push({ value: v.values[i] });
                    }
                  }
                });

                self.availableAttributes = attrs;
              }
            }
          },

          onResourceUpdate: function(n, o) {
            var attrs = [],
                self = $scope.resourceRequestNeed;

            if (o) {
              self.model.values = [];
            }

            if (n !== o) {
              if (self.requestType === 'resource') {

                self.model.type = n.resourceTemplateName;

                self.model.resourceTemplateId = n.resourceTemplateId;
                self.model.resourceTemplateName = n.resourceTemplateName;
                self.model.resourceId = n.id;
                self.model.resourceName = n.name;

                angular.forEach(n.fields, function(v, k) {
                  var i, ii;

                  if (v.values instanceof Array) {
                    for (i = 0, ii = v.values.length; i < ii; i++) {
                      attrs.push({ value: v.values[i] });
                    }
                  }else if (v.stringValue) {
                    attrs.push({ value: v.stringValue });
                  }
                });

                self.selectizeConfig.items = self.availableAttributes = attrs;
              }
            }
          },

          onQuantityUpdate: function(n, o) {
            var self = $scope.resourceRequestNeed;
            if (n <= 0) {
              self.model.quantity = 1;
            }
          },

          onResourceRequestComplete: function(n, o) {
            var self = $scope.resourceRequestNeed;

            self.hasError = self.checkValid();

          }


        };

        $scope.resourceRequestNeed.init();

      }]

    };

}]);
